module.exports = __webpack_public_path__ + "static/img/btn_sp03.4bda987.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sv/sv001/btn_sp03.jpg
// module id = BOrx
// module chunks = 0